var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { registerAutomotive } from '../../registryCore';
import { createAutoGroup, num, setState, } from '../../helpers';
import { themeFromProps } from '../../themes';
import { fitTextX, fluidFont, resolveBounds } from '../../layout';
registerAutomotive('tpms', function (props, app) {
    var _a;
    var theme = themeFromProps(props);
    var pressures = (_a = props.pressures) !== null && _a !== void 0 ? _a : [32, 32, 32, 32];
    var lowThreshold = num(props, 'lowThreshold', 25);
    var bounds = resolveBounds(props, 168, 100);
    var group = createAutoGroup(app, 'tpms', __assign(__assign({}, props), { width: bounds.width, height: bounds.height }), 'tpms');
    var panelW = bounds.innerWidth;
    var panelH = bounds.innerHeight;
    var compact = panelH < 64 || panelW < 100;
    var title = compact ? 'TPMS' : 'TIRE PRESSURE';
    var titleSize = fluidFont(compact ? 8 : 9, bounds, 7, 11);
    var titleH = Math.max(compact ? 12 : 14, Math.min(20, panelH * 0.22));
    var gap = compact ? 3 : 5;
    // Row of four only when cells stay tall enough — otherwise 2×2 avoids a crushed strip.
    var rowCandidate = panelW >= panelH * 1.35 && panelH >= 56;
    var rowLayout = rowCandidate;
    var cellW = rowLayout
        ? (panelW - gap * 5) / 4
        : (panelW - gap * 3) / 2;
    var cellH = rowLayout
        ? Math.max(28, panelH - titleH - gap * 2)
        : Math.max(22, (panelH - titleH - gap * 3) / 2);
    var gridTop = titleH + gap;
    group.add(app.roundedRect({ width: panelW, height: panelH, cornerRadius: 8, fill: '#111827', stroke: theme.dialStroke, strokeWidth: 1.5, listening: false }), app.text({
        text: title,
        x: fitTextX(title, titleSize, panelW),
        y: Math.max(4, (titleH - titleSize) / 2),
        fontSize: titleSize,
        fontWeight: 'bold',
        fill: theme.textMuted,
        listening: false,
    }));
    var positions = rowLayout
        ? [
            { x: gap, y: gridTop, label: 'FL' },
            { x: gap * 2 + cellW, y: gridTop, label: 'FR' },
            { x: gap * 3 + cellW * 2, y: gridTop, label: 'RL' },
            { x: gap * 4 + cellW * 3, y: gridTop, label: 'RR' },
        ]
        : [
            { x: gap, y: gridTop, label: 'FL' },
            { x: gap * 2 + cellW, y: gridTop, label: 'FR' },
            { x: gap, y: gridTop + cellH + gap, label: 'RL' },
            { x: gap * 2 + cellW, y: gridTop + cellH + gap, label: 'RR' },
        ];
    var labelSize = Math.max(7, Math.min(11, cellH * 0.26));
    var valueSize = Math.max(11, Math.min(22, cellH * 0.42));
    var texts = [];
    positions.forEach(function (pos, i) {
        var _a;
        var psi = (_a = pressures[i]) !== null && _a !== void 0 ? _a : 32;
        var low = psi < lowThreshold;
        group.add(app.roundedRect({
            x: pos.x,
            y: pos.y,
            width: cellW,
            height: cellH,
            cornerRadius: 6,
            fill: low ? '#450a0a' : '#1f2937',
            stroke: low ? theme.warning : theme.dialStroke,
            strokeWidth: 1,
            listening: false,
        }), app.text({
            text: pos.label,
            x: pos.x + 4,
            y: pos.y + Math.max(2, cellH * 0.08),
            fontSize: labelSize,
            fontWeight: 'bold',
            fill: theme.textMuted,
            listening: false,
        }));
        var t = app.text({
            text: "".concat(psi),
            x: pos.x + fitTextX("".concat(psi), valueSize, cellW),
            y: pos.y + cellH * 0.58,
            fontSize: valueSize,
            fontWeight: 'bold',
            fill: low ? theme.warning : theme.text,
            textAlign: 'left',
            textBaseline: 'middle',
            listening: false,
        });
        texts.push(t);
        group.add(t);
    });
    group.metadata.refresh = function (next) {
        next.forEach(function (psi, i) {
            var low = psi < lowThreshold;
            if (texts[i]) {
                texts[i].text = "".concat(psi);
                texts[i].fill = low ? theme.warning : theme.text;
            }
        });
    };
    setState(group, { pressures: pressures, lowThreshold: lowThreshold, width: bounds.width, height: bounds.height });
    return group;
});
registerAutomotive('canViewer', function (props, app) {
    var _a;
    var signals = (_a = props.signals) !== null && _a !== void 0 ? _a : { 'engine.rpm': 2500, 'vehicle.speed': 60 };
    var bounds = resolveBounds(props, 220, 88);
    var group = createAutoGroup(app, 'canViewer', __assign(__assign({}, props), { width: bounds.width, height: bounds.height }), 'canViewer');
    var entries = Object.entries(signals).slice(0, num(props, 'maxRows', 20));
    var rowH = Math.max(11, Math.floor(bounds.innerHeight / Math.max(entries.length, 1)));
    var maxRows = Math.max(1, Math.floor(bounds.innerHeight / rowH));
    var visible = entries.slice(0, maxRows);
    group.add(app.rect({ width: bounds.innerWidth, height: bounds.innerHeight, fill: '#111827', stroke: '#374151', strokeWidth: 1, listening: false }));
    var rows = [];
    visible.forEach(function (_a, i) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        var row = app.text({
            text: "".concat(key, ": ").concat(val).slice(0, Math.max(8, Math.floor(bounds.innerWidth / 6))),
            x: 4,
            y: 2 + i * rowH,
            fontSize: Math.max(8, Math.min(10, rowH - 2)),
            fill: '#d1d5db',
            listening: false,
        });
        rows.push(row);
        group.add(row);
    });
    group.metadata.refresh = function (next) {
        Object.entries(next)
            .slice(0, rows.length)
            .forEach(function (_a, i) {
            var _b = __read(_a, 2), key = _b[0], val = _b[1];
            if (rows[i])
                rows[i].text = "".concat(key, ": ").concat(val);
        });
    };
    setState(group, { signals: signals, width: bounds.width, height: bounds.height });
    return group;
});
